// Find Launches needs the permission SCORM attempt details does.
export { readLaunchesPermission } from '../scorm/scorm'

/** Where Find Launches lives. */
export const launchesPath = '/launch/launches'

/** The API's launch search, and its export at `${launchesApi}/export`. */
export const launchesApi = '/launch/v1/launches'
